import { render, staticRenderFns } from "./WorkspaceOneDrive.vue?vue&type=template&id=84da8df8&scoped=true"
import script from "./WorkspaceOneDrive.vue?vue&type=script&lang=js"
export * from "./WorkspaceOneDrive.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceOneDrive.vue?vue&type=style&index=0&id=84da8df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84da8df8",
  null
  
)

export default component.exports